import './ErrorPage.scss'

import Layout from '@componentsfld/core/Layout'
import { PageProps } from 'gatsby'
import React, { FunctionComponent } from 'react'
import EasySoftwareBreadcrumbs, {
  BreadcrumbItem,
} from 'Shared/components/EasySoftwareBreadcrumbs/EasySoftwareBreadcrumbs'
import PuxButton from 'Root/Shared/components/PuxButton/PuxButton'
import PuxPicture from 'Root/Shared/components/content/mediaImage/PuxPicture'
import PuxWysiwyg from 'Shared/components/PuxWysiwyg/PuxWysiwyg'
import { PuxMetaTagsType } from 'Shared/utils/PuxMetaTags'

import PuxMetaTagsGatsby from 'Root/Shared/utils/PuxMetaTagsGatsby'
import { getLocalizedData, getLocalizedUrl } from 'Shared/utils/localeURL'
import {
  ErrorPageDataType,
  ResolvedErrorPageData,
  resolveErrorPage,
} from 'Shared/utils/resolveErrorPage'

const rootClass = `pux-notfound`

export interface puxErrorPageType extends PageProps {
  data: {
    orchard: {
      puxErrorPage: ErrorPageDataType[]
    }
  }
  pageContext: {
    breadcrumbs?: [BreadcrumbItem]
    pagePath: string
    metaTags: PuxMetaTagsType
    resStrings: {
      key: string
      value: string
    }[]
  }
}

export const ErrorPageContent: FunctionComponent<{
  breadcrumbs?: [BreadcrumbItem]
  pageData: ResolvedErrorPageData
}> = ({ breadcrumbs, pageData }) => {
  const hasImage = Boolean(
    pageData.errorPageImage?.resizePaths?.find((path) => path) ||
      pageData.errorPageImage?.resizePathsFallback?.find((path) => path)
  )

  return (
    <div className={`${rootClass} NotFound`}>
      <EasySoftwareBreadcrumbs items={breadcrumbs} showAll />
      <div className="Container">
        <div className={`${rootClass}-content`}>
          <div className={`${rootClass}-text`}>
            <div
              className={`${rootClass}-heading`}
              role="heading"
              aria-level={1}
            >
              <PuxWysiwyg content={pageData.errorPageHeading} headless />
            </div>
            <PuxButton
              buttonClassName={`${rootClass}-button`}
              buttonIcon="arrows/arrow-right"
              buttonLink={pageData.errorPageButton}
              buttonSize="large"
              buttonType="border"
            />
          </div>
          {hasImage && pageData.errorPageImage && (
            <div className={`${rootClass}-visual`}>
              <PuxPicture
                {...pageData.errorPageImage}
                disableLazyload
                height={610}
                width={610}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const getErrorPageData = (props: puxErrorPageType) => {
  const { isoCode } = getLocalizedData(
    process.env.LOCALE ?? ``,
    process.env.PROJECT ?? ``
  )
  return resolveErrorPage(
    props.data?.orchard?.puxErrorPage,
    isoCode,
    getLocalizedUrl(`${isoCode}/`)
  ).pageData
}

const ErrorPage: FunctionComponent<puxErrorPageType> = (props) => {
  const pageData = getErrorPageData(props)

  return (
    <Layout
      localizedPath={pageData.localization?.localizations}
      resStrings={props.pageContext.resStrings}
    >
      <ErrorPageContent
        breadcrumbs={props.pageContext.breadcrumbs}
        pageData={pageData}
      />
    </Layout>
  )
}

export default ErrorPage

export function Head(props: puxErrorPageType) {
  const pageData = getErrorPageData(props)
  return (
    <PuxMetaTagsGatsby
      {...props.pageContext.metaTags}
      {...pageData.puxMetaTags}
      localizedPaths={[]}
    />
  )
}
